<template>
  <div>
    <my-notification :icon="'warning'">
      <template #title>
        {{ $t('compScenarioDocsNotes.title') }}
      </template>
      <p>
        <b>{{ $t('compScenarioDocsNotes.title-1') }}</b
        ><br />
        <span v-html="$t('compScenarioDocsNotes.notes-1')" /> <br /><br />
        <b>{{ $t('compScenarioDocsNotes.title-2') }}</b
        ><br />
        {{ $t('compScenarioDocsNotes.notes-2') }}<br /><br />
        <b>{{ $t('compScenarioDocsNotes.title-3') }}</b> <br />
        {{ $t('compScenarioDocsNotes.notes-3') }}
      </p>
    </my-notification>
  </div>
</template>

<script>
export default {
  name: 'Notes',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue')
  }
}
</script>
